/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const MobileValidationWorkflowList = zod.strictObject({
    instance_id: zod.string(),
    name: zod.string(),
    display_name: zod.string().nullable(),
    validation_status: zod.string(),
    rejection_comment: zod.string().nullable(),
    created_at: zod.number(),
    updated_at: zod.number().nullable(),
    history: zod.array(
        zod.strictObject({
            level: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
            updated_at: zod.iso.datetime({ offset: true }),
            status: zod
                .enum([
                    'ACCEPTED',
                    'REJECTED',
                    'SKIPPED',
                    'UNKNOWN',
                    'SUBMISSION',
                    'NEW_VERSION',
                ])
                .optional()
                .describe(
                    '\* `ACCEPTED` - Accepted\n\* `REJECTED` - Rejected\n\* `SKIPPED` - Skipped\n\* `UNKNOWN` - Unknown\n\* `SUBMISSION` - Submission\n\* `NEW_VERSION` - New version',
                ),
            comment: zod.string().optional(),
            updated_by: zod.string().nullable(),
            created_by: zod.string(),
        }),
    ),
});

export type MobileValidationWorkflowList = zod.input<
    typeof MobileValidationWorkflowList
>;
export type MobileValidationWorkflowListOutput = zod.output<
    typeof MobileValidationWorkflowList
>;
